import { Autocomplete, TextField } from "@mui/material";
import Component from "components/Component";
import DefaultLoader from "components/common/DefaultLoader";
import Disabled from "components/common/Disabled";
import * as labels from "config.labels";
import { useDispatch, useSelector } from "react-redux";
import * as staticDataService from "services/staticDataService";
import * as programActions from "store/actions/input/program/programActions";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import * as programSelectors from "store/selectors/input/program/programSelectors";

export const ProductLineComponent = () => {
  const dispatch = useDispatch();
  const translateLabel = staticDataHooks.useTranslator("uiLabels");

  const productLine = useSelector(programSelectors.selectResolvedProgram)
    ?.productLine;

  const {
    data: generalConfiguration,
    isLoading,
    error: fetchError,
  } = staticDataService.useConfigQuery("general_configuration");

  const productLineChoices = generalConfiguration?.productLineChoices ?? [];

  const productLineLabel = translateLabel(labels.PRODUCT_LINE, {
    default: "Product Line",
  });

  const noProductLineChoices = translateLabel(labels.NO_PRODUCT_LINE, {
    default: "No Product Lines were configured",
  });

  return (
    <Component
      title={productLineLabel}
      subtitle={translateLabel(labels.PRODUCT_LINE_SUBTITLE, {
        default:
          "The product line determines which default exposures are appropriate.",
      })}
    >
      {isLoading ? (
        <DefaultLoader
          style={{
            width: "100%",
            height: "60px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          size={60}
        />
      ) : (
        <Disabled ifReadOnly>
          <Autocomplete
            options={productLineChoices || []}
            getOptionKey={({ key }) => key}
            getOptionLabel={({ name }) => name ?? ""}
            value={
              productLineChoices?.find((x) => x.key === productLine) ?? null
            }
            onChange={(_, value) => {
              dispatch(
                programActions.updateProgram({
                  productLine: value?.key ?? null,
                })
              );
            }}
            noOptionsText={noProductLineChoices}
            renderInput={(params) => (
              <TextField
                {...params}
                variant={"filled"}
                label={productLineLabel}
                InputLabelProps={{ shrink: true }}
                error={!!fetchError}
              />
            )}
          />
        </Disabled>
      )}
    </Component>
  );
};

export default ProductLineComponent;
